import React from "react";
import styles from "./Termos.module.css";

function TermosUso() {
    return (
        <div className={styles.pageWrapper}>            
            <section className={styles.bannerHeader}>
                <div className={styles.bannerContent}>
                    <h1>Termos e Condições de Uso</h1>
                    <p className={styles.lastUpdate}>Última atualização: 25 de Março de 2026</p>
                </div>
            </section>

            <main className={styles.containerTermos}>
                <section>
                    <h2>1. Aceitação dos Termos</h2>
                    <p>
                        Ao acessar, navegar e utilizar o site da <strong>CPP Contabilidade</strong>, você reconhece e declara que leu, compreendeu e concorda expressamente em cumprir todos os termos e condições aqui estabelecidos, bem como todas as leis, normas e regulamentações vigentes e aplicáveis. Esta aceitação constitui um acordo legalmente vinculativo entre você e a nossa empresa.
                    </p>
                    <p>
                        Caso você não concorde com qualquer disposição destes Termos de Uso, parcial ou integralmente, você não possui autorização para utilizar nossos serviços ou explorar nosso conteúdo, devendo interromper o seu acesso e a utilização do site imediatamente.
                    </p>
                    <p>
                        Ressaltamos ainda que todos os materiais, textos, gráficos e designs contidos neste site são de propriedade exclusiva da <strong>CPP Contabilidade</strong> e encontram-se rigorosamente protegidos pelas leis de direitos autorais, propriedade intelectual e marcas comerciais.
                    </p>
                </section>

                <section>
                    <h2>2. Descrição dos Serviços</h2>
                    <p>
                        O site da <strong>CPP Contabilidade</strong> tem como objetivo apresentar nosso portfólio de soluções corporativas integradas e atuar como um canal facilitador para nossos clientes. Nossa especialidade abrange de forma completa as rotinas de Contabilidade, Recursos Humanos e Gestão Empresarial.
                    </p>
                    <p>Nossos principais serviços oferecidos incluem, mas não se limitam a:</p>
                    <ul>
                        <li><strong>Contabilidade e Tributos:</strong> Gestão contábil completa para empresas, planejamento tributário estratégico e declarações de Imposto de Renda.</li>
                        <li><strong>Gestão de RH e Saúde Ocupacional:</strong> Administração de departamento pessoal, rotinas de recursos humanos e coordenação de exames médicos ocupacionais.</li>
                        <li><strong>Regularização Empresarial:</strong> Assessoria legal para emissão de certificados, alvarás de funcionamento e demais documentações obrigatórias.</li>
                    </ul>
                    <p>
                        A efetiva prestação de qualquer serviço descrito no site está sujeita à celebração de contratos específicos, alinhados à legislação de cada setor. Reservamo-nos o direito de atualizar, modificar ou descontinuar a apresentação de qualquer serviço em nossa plataforma a qualquer momento.
                    </p>
                </section>

                <section>
                    <h2>3. Responsabilidades e Fornecimento de Informações</h2>
                    <p>
                        A excelência dos nossos serviços contábeis e de RH depende da veracidade dos dados fornecidos. Portanto, o usuário compreende e se compromete a:
                    </p>
                    <ul>
                        <li><strong>Fornecer dados precisos:</strong> Garantir que todas as informações e documentos enviados sejam exatos, completos e atualizados, comunicando prontamente à <strong>CPP Contabilidade</strong> qualquer alteração relevante.</li>
                        <li><strong>Uso ético e legal:</strong> Não utilizar o site ou nossos canais de atendimento para fins ilícitos, fraudulentos ou que prejudiquem terceiros.</li>
                        <li><strong>Integridade do sistema:</strong> Não tentar comprometer a segurança da plataforma, disseminar vírus ou realizar engenharia reversa em qualquer sistema disponibilizado.</li>
                    </ul>
                    <p>
                        A <strong>CPP Contabilidade</strong> não se responsabiliza por multas, atrasos ou prejuízos decorrentes de informações incorretas, incompletas ou omitidas pelo cliente na execução dos serviços.
                    </p>
                </section>

                <section>
                    <h2>4. Propriedade Intelectual e Licença de Uso</h2>
                    <p>
                        Todo o conteúdo deste site (logotipos, textos, gráficos, ícones e códigos) é de propriedade exclusiva da <strong>CPP Contabilidade</strong> e protegido pelas leis de direitos autorais.
                    </p>
                    <p>
                        Concedemos ao usuário uma licença temporária, não exclusiva e intransferível para acessar e visualizar os materiais contidos neste site, exclusivamente para fins pessoais e de relacionamento comercial conosco. Esta licença restringe expressamente o usuário de:
                    </p>
                    <ul>
                        <li>Modificar, copiar ou utilizar os materiais para exibição pública ou fins comerciais não autorizados.</li>
                        <li>Remover quaisquer notificações de direitos autorais ou de propriedade dos materiais.</li>
                        <li>Transferir, reproduzir ou "espelhar" os materiais em outros servidores.</li>
                    </ul>
                    <p>
                        Esta licença será automaticamente rescindida caso você viole qualquer uma dessas restrições, reservando-nos o direito de revogá-la a qualquer momento.
                    </p>
                </section>

                <section>
                    <h2>5. Confidencialidade e Proteção de Dados (LGPD)</h2>
                    <p>
                        A <strong>CPP Contabilidade</strong> lida com dados sensíveis diariamente e leva a privacidade a sério. Comprometemo-nos a tratar todas as informações fornecidas de forma estritamente confidencial e em total conformidade com a <strong>Lei Geral de Proteção de Dados Pessoais (Lei nº 13.709/2018)</strong>.
                    </p>
                    <p>
                        Os dados coletados serão utilizados exclusivamente para a execução dos serviços contratados e não serão comercializados ou compartilhados com terceiros não autorizados, exceto por determinação legal, cumprimento de obrigações fiscais ou mediante autorização expressa do titular. Para mais detalhes, consulte nossa Política de Privacidade.
                    </p>
                </section>

                <section>
                    <h2>6. Isenção e Limitações de Responsabilidade</h2>
                    <p>
                        Embora nos empenhemos para manter o site atualizado e seguro, não oferecemos garantias de que o acesso será contínuo ou livre de erros. O site e seus materiais são fornecidos "no estado em que se encontram".
                    </p>
                    <p>
                        Em nenhuma circunstância a <strong>CPP Contabilidade</strong>, seus sócios, fornecedores ou parceiros serão responsabilizados por quaisquer danos diretos, indiretos ou incidentais — incluindo lucros cessantes, perda de dados ou interrupção de negócios — decorrentes do uso ou da impossibilidade de uso deste site e de suas ferramentas.
                    </p>
                </section>

                <section>
                    <h2>7. Precisão dos Materiais e Links de Terceiros</h2>
                    <p>
                        Os materiais exibidos no site podem incluir erros técnicos, tipográficos ou fotográficos. A <strong>CPP Contabilidade</strong> pode realizar alterações no conteúdo do site a qualquer momento, sem aviso prévio, não assumindo o compromisso de atualização em tempo real de todas as informações.
                    </p>
                    <p>
                        Além disso, nosso site pode conter links para plataformas governamentais (Receita Federal, eSocial, etc.) ou outros sites de terceiros. A inclusão desses links é apenas uma facilidade, e a <strong>CPP Contabilidade</strong> não endossa nem se responsabiliza pelas políticas de privacidade ou conteúdos dessas plataformas externas.
                    </p>
                </section>

                <section>
                    <h2>8. Modificações nos Termos de Uso</h2>
                    <p>
                        A <strong>CPP Contabilidade</strong> reserva-se o direito de revisar e alterar estes Termos de Uso a qualquer momento, de forma a refletir mudanças na legislação ou em nossos serviços. Ao continuar a acessar e utilizar o site após essas atualizações, você concorda em se vincular à versão mais recente deste documento.
                    </p>
                </section>

                <section>
                    <h2>9. Legislação Aplicável e Foro</h2>
                    <p>
                        Estes termos são regidos e interpretados exclusivamente de acordo com as leis da República Federativa do Brasil. Fica eleito o foro da comarca de <strong>SÃO PAULO / SP</strong> para dirimir quaisquer dúvidas ou litígios oriundos deste documento, com renúncia expressa a qualquer outro, por mais privilegiado que seja.
                    </p>
                </section>

                <section className={styles.contatoTermos}>
                    <p>Dúvidas sobre os nossos termos? Entre em contato em: <strong><a href="mailto:Para faleconosco@cppcontabilidade.com.br" className={styles.emailLink}> faleconosco@cppcontabilidade.com.br</a></strong></p>
                </section>
            </main>
        </div>
    );
}

export default TermosUso;